<template>
  <transition name="slide-fade" >
    <div  id="academicsHolder" >
      <div class="uk-child-width-1-1" uk-grid>
        <!--<div class=" uk-background-secondary uk-light" style="padding: 20px; color: rgb(197,179,88) !important;">
          <div class="uk-container uk-container-small ">
            <p class="uk-text-center uk-text-lead@l uk-text-large@l">
              We provide security and support for all stakeholders
            </p>
          </div>
        </div>-->

        <div class="uk-padding  uk-margin-remove-top">
          <div class="uk-container uk-container-small">
            <h1 class="uk-heading-line uk-text-center specHeading">University Information System Services</h1>
            <div class="uk-child-width-1-2@m" uk-grid>
              <div>
                University Information System Services (UNISS) is the department that has
                responsibility for all of Northern Caribbean University’s technology which includes
                Networking, Wi-Fi, desktop, servers, and all other technology needed to drive university
                technological processes.
                <br><br>
                UNISS is dedicated to providing a reliable network environment to facilitate education, research,
                operations and Institutional approved business services for the Northern Caribbean University Community.

              </div>
              <div>
                <ul class="uk-list uk-list-bullet">
                  UNISS comprises of five (5) different areas
                  <li>Application Development</li>
                  <li>Infrastructure Support Services</li>
                  <li>Computer Labs</li>
                  <li>ID Services</li>
                  <li>Help Desk </li>
                </ul>
              </div>
              <div>
                <div class="uk-child-width-1-2@s uk-child-width-1-2@l " uk-grid>
                  <div>
                    <img class="uk-border-circle" src="../assets/uniss1.jpg" width="200" height="200" alt="Border circle">
                  </div>
                  <div>
                    <img class="uk-border-circle" src="../assets/uniss1.png" width="200" height="200" alt="Border circle">
                  </div>
                </div>
              </div>
              <div>
                <div class=" uk-child-width-1-2@l uk-child-width-1-2@s" uk-grid>
                  <div>
                    <img class="uk-border-circle" src="../assets/uniss2.png" width="200" height="200" alt="Border circle">
                  </div>
                  <div>
                    <img class="uk-border-circle" src="../assets/uniss3.png" width="200" height="200" alt="Border circle">
                  </div>

                </div>
              </div>
            </div>
            <!--<div class="uk-child-width-1-1@m">
              <hr class="uk-divider-icon">

            </div>-->
          </div>
        </div>

      </div>
    </div>
  </transition>
</template>

<script>
    export default {
        name: "uniss",
      mounted(){
        window.scrollTo(0, 0);
      },
      metaInfo: {
        // Children can override the title.
        title: 'NCU University Information System Services (UNISS)',
        // Result: My Page Title ← My Site
        // If a child changes the title to "My Other Page Title",
        // it will become: My Other Page Title ← My Site
        //titleTemplate: '%s ← My Site',
        // Define meta tags here.
        meta: [
          {'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8'},
          {name: 'viewport', content: 'width=device-width, initial-scale=1'},
          {name: 'description', content: 'Department of University Information System Services at Northern Caribbean University '}
        ]
      }
    }
</script>

<style scoped>

</style>
